import { useIsPhone } from '@/hooks/phone/useIsPhone';
import { Category } from './types/Category';

interface Props {
  category: Category;
  selected?: boolean;
  onClick: () => void;
}

export const ArticleCategory = ({ category, selected, onClick }: Props) => {
  const { isPhone } = useIsPhone();

  const textColor = isPhone ? 'text-phone-primary' : 'text-[#fb7184]';
  const bgColor = isPhone ? 'bg-phone-primary' : 'bg-[#fb7184]';
  const borderColor = isPhone ? 'border-phone-primary' : 'border-[#fb7184]';
  return (
    <li
      key={category.id}
      className={
        selected
          ? ` w-28 ml-[10px] mb-4 ${bgColor} text-center text-[#fff] rounded-3xl pt-[7px] pl-5 pr-5 pb-[7px] justify-center text-base font-bold`
          : ` w-28 ml-[10px] mb-4 text-center border ${borderColor}  rounded-3xl pt-[7px] px-5 pb-[7px] justify-center ${textColor}  text-base font-bold`
      }
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <span>{category.name}</span>
    </li>
  );
};
